import {FieldDataType, XyiconFeature} from "../../../../generated/api/base";
import {FieldDataTypes} from "../FieldDataTypes";
import type {User} from "../../User";
import {PeopleFieldSettings} from "../../../../ui/modules/settings/modules/field/datatypes/PeopleFieldSettings";
import {PeopleFieldSettingsV5} from "../../../../ui/5.0/details/PeopleFieldSettingsV5";
import {PeopleMultipleChoiceInputV5} from "../../../../ui/5.0/details/datatypes/PeopleMultipleChoiceInputV5";
import {PeopleMultipleChoiceInput} from "../../../../ui/widgets/input/people/PeopleMultipleChoiceInput";
import type {AppActions} from "../../../state/AppActions";
import {MassFieldMultiInput} from "../../../../ui/modules/abstract/sidepanel/tabs/details/field/mass/datatypes/MassFieldMultiInput";
import {MassFieldMultiInputV5} from "../../../../ui/5.0/details/datatypes/mass/MassFieldMultiInputV5";
import {FilterOperator} from "../../filter/operator/FilterOperator";
import {renderUserValue} from "./PeopleSingle";

const parseValue = (userIds: string[], actions: AppActions) => {
	if (Array.isArray(userIds) && actions) {
		const users = userIds.map((userId: string) => actions.getFeatureItemById<User>(userId, XyiconFeature.User));

		return users.filter((user) => !!user);
	}

	return [];
};

const renderValue = (usersMaybe?: User[]) => {
	return usersMaybe?.map(renderUserValue).join(", ");
};

export function configurePeopleMultiple() {
	FieldDataTypes.configure({
		id: FieldDataType.PeopleMultipleChoiceList,
		title: "People",
		converter: parseValue,
		formatter: renderValue,
		input: PeopleMultipleChoiceInput,
		inputV5: PeopleMultipleChoiceInputV5,
		massInput: MassFieldMultiInput,
		massInputV5: MassFieldMultiInputV5,
		operatorsArray: [
			FilterOperator.CONTAINS,
			FilterOperator.DOES_NOT_CONTAIN,
			FilterOperator.IS_BLANK,
			FilterOperator.IS_NOT_BLANK,
			FilterOperator.IS_ANY_OF,
			FilterOperator.IS_NOT_ANY_OF,
		],
		settings: PeopleFieldSettings,
		settingsV5: PeopleFieldSettingsV5,
	});
}
